import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import styled from 'styled-components';
import UnstyledCollectionList from '../components/CollectionList';
import Table from '../components/Table';
import dataStore from '../models/dataStore';
import useCollectionMeasuredTimes from '../utils/useCollectionMeasuredTimes';
import clearCallstack from '../utils/clearCallstack';
const Wrapper = styled.div `
  display: grid;
  grid-template-areas: 'list items';
  grid-template-columns: 200px 1fr;
  overflow: hidden;
  height: 100%;
`;
const CollectionList = styled(UnstyledCollectionList) `
  grid-area: list;
`;
const Items = styled(Table) `
  grid-area: items;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: relative;
`;
const Profiler = () => {
    const [collectionName, setCollectionName] = useState();
    const collectionsItem = dataStore.useItem('collections');
    const collection = useMemo(() => collectionsItem?.items.find(c => c.name === collectionName), [collectionsItem, collectionName]);
    const items = useCollectionMeasuredTimes(collectionName || '');
    const measuredTimes = useMemo(() => items.map(item => ({
        id: item.id,
        time: item.time.toLocaleString(),
        measuredTime: `${item.measuredTime < 1 ? '< 1' : item.measuredTime.toFixed(0)} ms`,
        selector: JSON.stringify(item.selector, null, 2),
        callstack: clearCallstack(item.callstack),
    })), [items]);
    return (_jsxs(Wrapper, { children: [_jsx(CollectionList, { value: collectionName, onChange: name => setCollectionName(name) }), collection
                ? (_jsx(Items, { items: measuredTimes, columns: [{
                            name: 'time',
                            label: 'Time',
                        }, {
                            name: 'measuredTime',
                            label: 'Measured Time',
                        }, {
                            name: 'selector',
                            label: 'Selector',
                        }, {
                            name: 'callstack',
                            label: 'Callstack',
                        }] }))
                : (_jsx(Items, { items: [], columns: [], placeholder: "Select a collection on the left" }))] }));
};
export default Profiler;
